import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import { withTheme } from '@glu/theming';
import { DAY } from '../utils/recurrence';
import { types } from './Recurrence.reducer';
import SchedulerContext from '../SchedulerContext';
import EveryN, { SELECT } from './EveryN';
import useStyles from './Monthly.styles';
import DayControl from './DaySelect';

const SemiMonthly = ({
  nSemiMonths, daysInSemiMonth, allowWeekend, canSetTime, hideLastDayInDays,
  multipleDays, minTime, maxTime, hideMinutes, everyN, onChange, ...rest
}) => {
  const {
    timePicker24Hour, disabled
  } = useContext(SchedulerContext);

  const classes = useStyles({
    timePicker24Hour, showingMultipleDays: false, canSetTime, ...rest
  });

  return (
    <div data-qa="semimonthly" className={`${classes.monthly} `}>
      {everyN && (
      <EveryN
        everyText={locale.get('schedulerReact.everyXMonths').split('{0}')}
        type={SELECT}
        min={1}
        max={12}
        value={nSemiMonths}
        onChange={(event) => onChange({
          type: types.SEMIMONTHLY,
          response: event.target.value
        })}
      />
      )}
      <div className={classes.dates}>
        {daysInSemiMonth.map((dayInMonth, index) => (
          <div className={classes.row} key={dayInMonth.id} data-qa="semi-monthly-row">
            <DayControl
              dayInMonth={dayInMonth}
              updateType={types.UPDATE_DAY_SEMI_MONTH}
              index={index}
              onChange={onChange}
              disabled={disabled}
              timePicker24Hour={timePicker24Hour}
              showingMultipleDays={false}
              canSetTime={canSetTime}
              allowWeekend={allowWeekend}
              hideLastDayInDays={hideLastDayInDays}
              minTime={minTime}
              maxTime={maxTime}
              hideMinutes={hideMinutes}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

SemiMonthly.propTypes = {
  /** Value of every x months */
  nSemiMonths: PropTypes.number,

  /** Controls whether to display every n control */
  everyN: PropTypes.bool,

  /** Option to set time on day */
  canSetTime: PropTypes.bool,

  /** Hides minute controls, only displaying hours to control * */
  hideMinutes: PropTypes.bool,

  /** Array of objects containing days in month */
  daysInSemiMonth: PropTypes.instanceOf(Array),

  /** Controls whether to display weekends in list of days */
  allowWeekend: PropTypes.bool,

  /** Hide 'last' day in days dropdown */
  hideLastDayInDays: PropTypes.bool,

  /** Enable multiple days to be added */
  multipleDays: PropTypes.bool,

  /** Minimum time value of input */
  minTime: PropTypes.string,

  /** Maximum time value of input */
  maxTime: PropTypes.string,

  /** Callback to set recurrence value */
  onChange: PropTypes.func.isRequired
};

SemiMonthly.defaultProps = {
  nSemiMonths: 1,
  everyN: true,
  daysInSemiMonth: [
    {
      day: 1,
      intervalType: DAY
    },
    {
      day: 2,
      intervalType: DAY
    }],
  allowWeekend: false,
  canSetTime: true,
  hideLastDayInDays: false,
  minTime: undefined,
  maxTime: undefined,
  hideMinutes: false,
  multipleDays: false
};

export const BareSemiMonthly = SemiMonthly;
export default withTheme(SemiMonthly);
